import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCircleFill6 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 128 128",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M64 117.333C93.4552 117.333 117.333 93.4552 117.333 64C117.333 34.5448 93.4552 10.6667 64 10.6667C34.5448 10.6667 10.6667 34.5448 10.6667 64C10.6667 93.4552 34.5448 117.333 64 117.333Z",
		stroke: "currentColor",
		strokeWidth: 10.6667,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M64 30C64 27.2386 66.2476 24.967 68.9864 25.3201C74.9323 26.0866 80.6452 28.2171 85.6672 31.5727C92.0808 35.8581 97.0795 41.949 100.031 49.0753C102.983 56.2017 103.755 64.0433 102.251 71.6085C100.746 79.1738 97.0314 86.1229 91.5772 91.5772C86.1229 97.0314 79.1738 100.746 71.6085 102.251C64.0433 103.755 56.2017 102.983 49.0753 100.031C41.949 97.0795 35.8581 92.0808 31.5727 85.6672C28.2171 80.6452 26.0866 74.9323 25.3201 68.9864C24.967 66.2476 27.2386 64 30 64L59 64C61.7614 64 64 61.7614 64 59L64 30Z",
		fill: "currentColor"
	})]
});
export default SvgCircleFill6;
